// extracted by mini-css-extract-plugin
export default {"header":"NewProfilesStatistics_header__ACoyi","item":"NewProfilesStatistics_item__1v+Ji","title":"NewProfilesStatistics_title__gT2Us","number":"NewProfilesStatistics_number__YaChP"};